// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0014 6C13.0014 3.79086 14.7922 2 17.0014 2C19.2105 2 21.0014 3.79086 21.0014 6C21.0014 8.20914 19.2105 10 17.0014 10C14.7922 10 13.0014 8.20914 13.0014 6ZM8.99708 8.14409L13.4895 15.1322L15.9263 11.2333L24.0014 22H0.179688L8.99708 8.14409Z"}}]};

const Image1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'image-1-filled',
    ref,
    icon: element,
  },
));

Image1FilledIcon.displayName = 'Image1FilledIcon';

export default Image1FilledIcon;
